import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { SharepointConnector } from '../../connector';

export const SharepointService = IntegrationService.make({
  connector: SharepointConnector,
  name: Integration_Service_Names_Enum.Sharepoint,
});
